import Swiper from 'swiper';

// Initialize Swiper
var swiper2 = new Swiper('.phone-thumb', {
  spaceBetween: 24,
  slidesPerView: 1,
  // freeMode: true,
  allowTouchMove: false,
  watchSlidesProgress: true,
});

var swiper = new Swiper('.phone-image-slider', {
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: '.interactive-slider-button-next',
    prevEl: '.interactive-slider-button-prev',
  },
  thumbs: {
    swiper: swiper2,
  },
  on: {
    slideChange: function () {
      // When the slide changes, update the active accordion item
      let activeIndex = swiper.activeIndex;
      setActiveAccordionItem(activeIndex);
    },
  },
});

// Function to set active accordion item based on the slide index
function setActiveAccordionItem(index) {
  const accordionItems = document.querySelectorAll('.slider-accordion-item');
  accordionItems.forEach((item, i) => {
    if (i === index) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

// Add click event to each accordion title
const accordionTitles = document.querySelectorAll(
  '.slider-accordion-item .title'
);
accordionTitles.forEach((title, index) => {
  title.addEventListener('click', function () {
    swiper.slideTo(index); // Change the swiper slide to the clicked accordion index
    setActiveAccordionItem(index); // Set the clicked accordion item as active
  });
});

// Initially set the first accordion item as active
setActiveAccordionItem(0);
